import dom from '../../utils/dom';
import { loadModal } from '../../AsyncLoader';
import PaymentPlanService from './PaymentPlanService';
import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';
import PaymentPlanErrorMessage from './PaymentPlanErrorMessage';
import UserFacingIdentifiers from '../../shared/UserFacingIdentifiers';
import ScreenReaderLoadingMessages from '../../utils/screen-reader/ScreenReaderLoadingMessages';
import announce from '../../utils/screen-reader/announce';

const { formButtonHandler } = window.tnew.handlers;

function getModalProperties() {
  const key = ComponentKeys.PAYMENT_PLANS;

  return {
    title: ContentStorage.get(key, 'PaymentPlanSummarySectionSubhead'),
    labelBtnSubmit: ContentStorage.get(key, 'ApplyPaymentPlanButtonLabel'),
    labelBtnCancel: ContentStorage.get(key, 'CancelButtonLabel'),
  };
}

export async function confirmSelectedPaymentPlanBillingSchedule(detailsHtml, scheduleId) {
  const Modal = await loadModal();

  const $form = dom.makeElement('form', { id: 'tn-payment-plan-confirmation-form' });

  $form.innerHTML = detailsHtml;

  const $errorMessageContainer = dom.makeElement('div');

  dom.prepend($form, $errorMessageContainer);

  const errorMessage = new PaymentPlanErrorMessage($errorMessageContainer);

  const { title, labelBtnSubmit, labelBtnCancel } = getModalProperties();

  return new Promise((resolve) => {
    const modal = Modal.presentForm({
      $form,
      title,
      labelBtnSubmit,
      labelBtnCancel,
      onCancel: () => resolve({ wasCancelled: true }),
      onSubmit: async () => {
        errorMessage.hide();

        const $btnSubmit = modal.getButtonSubmit();
        formButtonHandler.applyBusyStyling($btnSubmit);

        announce(ScreenReaderLoadingMessages.Start);

        const { isSuccessful } = await PaymentPlanService.applyPaymentPlan(scheduleId);

        if (!isSuccessful) {
          modal.enableForm();

          errorMessage.show();

          modal.scrollToTop();

          formButtonHandler.resetButtonStyling($btnSubmit);

          return;
        }

        window.location.assign(`/cart/payment#${UserFacingIdentifiers.appliedPaymentPlanHeading}`);
        window.location.reload();
      },
    });
  });
}
